/* eslint-disable @typescript-eslint/no-explicit-any */
import { LottiePlayer } from "@lottiefiles/lottie-player";
import { Rive, EventType, RiveEventType} from "@rive-app/canvas";
declare global {
    interface Window {
        itemsAnimData: {
            urls: string[];
        };
    }
}

export default function initItemsAnim() {
    const $itemsAnimContainer = document.querySelectorAll('.block-items-anim');

    $itemsAnimContainer.forEach($container => {
        new ItemsAnim($container);
    });
}

class ItemsAnim {
    $el: Element;
    $lottie: Element | null;
    $rive: Rive | null = null;

    constructor($el: Element) {
        this.$el = $el;
        if (this.$el) {
            this.$lottie = $el.querySelector('.js-lottie-wrapper');

            const riveCanvas = this.$el.querySelector(".rive-animation") as HTMLCanvasElement;

            if (this.$lottie) {
                this.onIntersection = this.onIntersection.bind(this);
                const observer = new IntersectionObserver(this.onIntersection);
                observer.observe(this.$lottie);
            }

            if (riveCanvas) {
                const src = riveCanvas.getAttribute('data-src');
                if (src) {
                    const riveInstance = new Rive({
                        src: src,
                        stateMachines: "State Machine 1",
                        canvas: riveCanvas,
                        autoplay: true,
                        automaticallyHandleEvents: true,
                        onLoad: () => {
                            riveInstance.resizeDrawingSurfaceToCanvas();
                        }
                    });

                    this.$rive = riveInstance;

                    riveInstance.on(EventType.RiveEvent, (riveEvent: RiveEvent) => {
                        const eventData = riveEvent.data;

                        if (eventData && typeof eventData === 'object' && 'type' in eventData) {
                            if ((eventData as any).type === RiveEventType.General) {
                                const generalEvent = eventData as {
                                    name: string;
                                    properties?: { [key: string]: any };
                                };


                            } else if ((eventData as any).type === RiveEventType.OpenUrl) {
                                const openUrlEvent = eventData as {
                                    name: string;
                                    url: string;
                                };
                                if (typeof window.itemsAnimData !== 'undefined') {
                                    const urls = window.itemsAnimData.urls;

                                    urls.forEach((url, index) => {
                                        if (index + 1 === parseInt(openUrlEvent.name)) {
                                            openUrlEvent.url = url;
                                        }
                                    })
                                }

                                // window.open(openUrlEvent.url, "_blank");
                            }
                        }
                    });

                    window.addEventListener('resize', () => {
                        if (this.$rive) {
                            this.$rive.resizeDrawingSurfaceToCanvas();
                        }
                    });
                }
            }
        }
    }

    onIntersection(entries: IntersectionObserverEntry[]) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const player = this.$lottie?.querySelector('lottie-player') as LottiePlayer;
                if (player) player.play();
            }
        });
    }
}

